var DEFAULT_SEPARATOR = "-";
var localeString = function (locale, separator) {
    if (separator === void 0) { separator = DEFAULT_SEPARATOR; }
    return localePartsFrom(locale).join(separator);
};
var localePartsFrom = function (locale) { return locale.split(/[_-]/); };
var formatLocaleString = function (localeString) {
    return localeString.replace("_", "-");
};
export { localeString, localePartsFrom, formatLocaleString };
